<script>
  import gql from 'graphql-tag'

  export default {
    props: ['gid'],
    apollo: {
      settings: {
        query: gql`query($gid: ID) {
          merchant(gid: $gid) { merchantUser {settings {pay {requireInvoiceField}}}}
        }`,
        variables() {
          return {
            gid: this.gid
          }
        },
        update: data => data.merchant.merchantUser.settings.pay
      }
    },
    data() {
      return {
        settings: {}
      }
    },
    methods: {
      switchIt() {
        this.$apollo.mutate({
          // Query
          mutation: gql`mutation ($requireInvoiceField: Boolean!, $gid: ID) {
            updateRequiredInvoiceField(input: {requireInvoiceField: $requireInvoiceField, userId: $gid}) {
              paySettings { requireInvoiceField }
            }
          }`,
          // Parameters
          variables: {
            requireInvoiceField: !this.settings.requireInvoiceField,
            gid: this.gid
          },
        }).then(result => {
          this.settings.requireInvoiceField = result.data.updateRequiredInvoiceField.paySettings.requireInvoiceField
          this.notifySuccess("Pay settings successfully updated")
        }, error => {
          this.gqlErrorHandler(error)
          this.settings.requireInvoiceField = !this.settings.requireInvoiceField
        })
      }
    }
  }
</script>

<template>
  <div>
    <section>
      <div class= "very-close-lines">
        Require invoice number on payment screen:<br>
        
        <small class="grey-text">Makes invoice number required for card and check transactions</small>
      </div>
      <!-- Switch -->
      <div class="switch">
        <label>
          Off
          <input type="checkbox" @click='switchIt' v-model='settings.requireInvoiceField' :disabled="$apollo.loading">
          <span class="lever"></span>
          On
        </label>
      </div>
    </section>
  </div>
</template>
